import { Quote } from "lucide-react";
import { Reveal } from "../Reveal";

export const TESTIMONIAL = {
  quote: [
    "I have had the privilege of working with Sempresera since 2015 and can say with complete confidence that they are among the most trustworthy and capable professionals I have encountered. Throughout our time working together, they have supported me and my business through a wide range of technical challenges, always with a rare combination of deep expertise, steady patience, and clear communication.",
    "What sets them apart is not only their ability to resolve issues quickly and effectively, but their commitment to making sure I understand what happened and why. This transparency is invaluable to me. No matter the complexity of the situation, my support engineer Joey L. brings a calm, reassuring presence and a level of responsiveness that puts me at ease.",
    "He consistently goes above and beyond expectations, and I never doubt that when Joey is involved, the issue will be resolved correctly and completely.",
    "I am deeply grateful to have him in my corner and recommend Sempresera and Joey L. without hesitation to anyone seeking expert, dependable, and thoughtful IT support.",
  ],
  author: "Tracy T.",
  role: "Founder",
  company: "Strategies For Success",
  url: "https://www.strategies-forsuccess.com",
  note: "A Sempresera client since 2015 — we host their website.",
};

export const reviewJsonLd = {
  "@context": "https://schema.org",
  "@type": "Review",
  reviewBody: TESTIMONIAL.quote.join(" "),
  author: { "@type": "Person", name: TESTIMONIAL.author },
  itemReviewed: { "@type": "Organization", name: "Sempresera", url: "https://sempresera.com/" },
};

export const Testimonials = () => (
  <section className="border-t border-white/5" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal>
        <p className="eyebrow">Client words</p>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Quote size={40} className="text-brand" strokeWidth={1.25} data-testid="testimonial-quote-icon" />
            <blockquote className="mt-8 space-y-6" data-testid="testimonial-quote">
              {TESTIMONIAL.quote.map((para, i) => (
                <p
                  key={i}
                  className={`leading-relaxed ${
                    i === 0
                      ? "font-display text-xl font-medium text-white md:text-2xl"
                      : "text-base text-[#C9D2DE]"
                  }`}
                >
                  {para}
                </p>
              ))}
            </blockquote>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={0.2}>
            <div className="glass h-full p-8 md:p-10" data-testid="testimonial-attribution">
              <p className="font-display text-2xl font-bold tracking-tight text-metallic">{TESTIMONIAL.author}</p>
              <p className="mt-2 text-sm text-[#C9D2DE]">
                {TESTIMONIAL.role},{" "}
                <a
                  href={TESTIMONIAL.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand transition-colors duration-200 hover:text-white"
                  data-testid="testimonial-company-link"
                >
                  {TESTIMONIAL.company}
                </a>
              </p>
              <p className="mt-6 border-t border-white/10 pt-6 text-sm leading-relaxed text-[#A8B4C2]">
                {TESTIMONIAL.note}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
